<template>
  <div class="style-editor">
    <h3>样式设置</h3>
    <!-- 颜色 -->
    <div>
      <label for="color">颜色:</label>
      <input
        id="color"
        v-model="state.selectedColor"
        type="color"
        @change="updateColor"
      />
    </div>
    <!-- 线条宽度 -->
    <div>
      <label for="weight">线条宽度:</label>
      <input
        id="weight"
        v-model="state.selectedWeight"
        type="range"
        min="1"
        max="10"
        step="1"
        @change="updateWeight"
      />
    </div>
    <!-- 透明度 -->
    <div>
      <label for="opacity">透明度:</label>
      <input
        id="opacity"
        v-model="state.selectedOpacity"
        type="range"
        min="0"
        max="1"
        step="0.05"
        @change="updateOpacity"
      />
    </div>

    <!-- 填充色 -->
    <div>
      <label for="fill-color">填充色:</label>
      <input
        id="fill-color"
        v-model="state.selectedFillColor"
        type="color"
        @change="updateFillColor"
      />
    </div>

    <!-- 填充透明度 -->
    <div>
      <label for="fill-opacity">填充透明度:</label>
      <input
        id="fill-opacity"
        v-model="state.selectedFillOpacity"
        type="range"
        min="0"
        max="1"
        step="0.05"
        @change="updateFillOpacity"
      />
    </div>
    <!-- 新增：边框样式编辑 -->
    <div>
      <label for="border-style">边框样式:</label>
      <select
        id="border-style"
        v-model="state.selectedBorderStyle"
        @change="updateBorderStyle"
      >
        <option value="solid">实线</option>
        <option value="dashed">虚线</option>
        <option value="dotted">点状线</option>
      </select>
    </div>
    <!-- 边框半径（仅适用于圆形图层） -->
    <div v-if="state.isCircle">
      <label for="radius">边框半径:</label>
      <input
        id="radius"
        v-model="state.selectedRadius"
        type="number"
        @change="updateRadius"
      />
    </div>

    <!-- 填充文字 -->
    <div>
      <label for="fill-text">填充文字:</label>
      <input
        id="fill-text"
        v-model="state.selectedFillText"
        type="text"
        @input="updateFillText"
      />
      <button type="button" @click="clearFillText">清除</button>
    </div>
    <div>
      <label for="icon-select">图标:</label>
      <button id="icon-select" @click="openIconSelector">选择图标</button>
    </div>
    <div v-if="state.showIconSelector" class="modal">
      <div class="modal-content">
        <div class="icon-list">
          <div
            v-for="(icon, index) in state.availableIcons"
            :key="index"
            class="icon-item"
            @click="selectIcon(icon)"
          >
            <Icon :icon="icon.url" />
            <span>{{ icon.name }}</span>
          </div>
        </div>
        <button type="button" @click="closeIconSelector">取消</button>
      </div>
    </div>
    <!-- 字体大小 -->
    <div>
      <label for="font-size">字体大小:</label>
      <input
        id="font-size"
        v-model="state.selectedFontSize"
        type="text"
        @input="updateFillText"
      />
    </div>
    <!-- 字体大小 -->
    <div>
      <label for="font-size">DX:</label>
      <input
        id="font-size"
        v-model="state.selectFontDx"
        type="text"
        @input="updateFillText"
      />
    </div>
    <!-- 字体大小 -->
    <div>
      <label for="font-size">DY:</label>
      <input
        id="font-size"
        v-model="state.selectFontDy"
        type="text"
        @input="updateFillText"
      />
    </div>

    <!-- 字体颜色 -->
    <div>
      <label for="font-color">字体颜色:</label>
      <input
        id="font-color"
        v-model="state.selectedFontColor"
        type="color"
        @change="updateFontColor"
      />
    </div>

    <!-- 字体家族 -->
    <div>
      <label for="font-family">字体家族:</label>
      <input
        id="font-family"
        v-model="state.selectedFontFamily"
        type="text"
        @input="updateFontFamily"
      />
    </div>
    <!-- 实时预览区域 -->
    <div class="preview">
      <h4>实时预览</h4>
      <div
        class="preview-layer"
        :style="{
          borderColor: state.selectedColor,
          borderWidth: state.selectedWeight + 'px',
          opacity: state.selectedOpacity,
          backgroundColor: state.selectedFillColor,
          borderStyle: state.selectedBorderStyle,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, watch } from 'vue'
import L from 'leaflet'
// import { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import 'leaflet-textpath'

const props = defineProps({
  layer: {
    type: Object,
    required: true,
  },
  map: {
    required: true,
  },
})
const state = reactive({
  selectedColor: '#ff3333',
  selectedWeight: 3,
  selectedOpacity: 0.6,
  selectedFillColor: '#ffffff',
  selectedFillOpacity: 0.6,
  selectedBorderStyle: 'solid',
  selectedRadius: 0,
  selectedFillText: '',
  isCircle: props.layer instanceof L.Circle, // 判断是否为圆形图层
  selectedIcon: { url: '', name: '' },
  availableIcons: [
    { url: 'https://api.iconify.design/gala:mouse.svg', name: 'Icon 1' },
    { url: 'https://api.iconify.design/gala:apple.svg', name: 'Icon 2' },
  ],
  showIconSelector: false,
  isIconSelected: false,
  isDragging: false,
  // 针对文字进行设置
  selectedFontFamily: '微软雅黑',
  selectedFontSize: '16px',
  selectedFontColor: '#333',
  selectFontDx: 185.070313,
  selectFontDy: 60,
})
watch(
  () => state.selectedColor,
  () => 'updateColor'
)
watch(
  () => state.selectedWeight,
  () => 'updateWeight'
)
watch(
  () => state.selectedOpacity,
  () => 'updateOpacity'
)
watch(
  () => state.selectedFillColor,
  () => 'updateFillColor'
)
watch(
  () => state.selectedFillOpacity,
  () => 'updateFillOpacity'
)
watch(
  () => state.selectedBorderStyle,
  () => 'updateBorderStyle'
)
watch(
  () => state.selectedRadius,
  () => 'updateRadius'
)
watch(
  () => state.selectedFillText,
  () => 'updateFillText'
)

const clearFillText = () => {
  state.selectedFillText = '' // 清空选中的文字内容
  updateFillText() // 调用更新方法，将空字符串应用到图层
}
const updateColor = () => {
  props.layer.setStyle({ color: state.selectedColor })
}
const updateWeight = () => {
  props.layer.setStyle({ weight: state.selectedWeight })
}
const updateOpacity = () => {
  props.layer.setStyle({ opacity: state.selectedOpacity })
}
const updateFillColor = () => {
  props.layer.setStyle({ fillColor: state.selectedFillColor })
}
const updateFillOpacity = () => {
  props.layer.setStyle({ fillOpacity: state.selectedFillOpacity })
}
const updateBorderStyle = () => {
  props.layer.setStyle({
    dashArray:
      state.selectedBorderStyle === 'solid'
        ? []
        : [
            state.selectedBorderStyle === 'dashed' ? 0.5 : 1,
            state.selectedBorderStyle === 'dashed' ? 1 : 0.25,
          ],
  })
}
const updateRadius = () => {
  props.layer.setRadius(state.selectedRadius)
}
const updateFillText = () => {
  props.layer.setText('')
  // 确保layer是可接受文字内容的图层类型，如自定义图层或特定插件提供的图层
  if (!props.layer || !props.layer.setText) {
    console.error(
      'Invalid layer provided or layer does not support setText method'
    )
    return
  }

  const textOptions = {
    fill: state.selectedFontColor,
    center: true,
    // 其他已有的文本设置
    offset: -5,
    attributes: {
      fill: state.selectedFontColor,
      'font-family': state.selectedFontFamily,
      'font-weight': 'bold',
      'font-size': state.selectedFontSize,
      'letter-spacing': '4px',
      // x: this.selectFontDx,
      // y: this.selectFontDy,
      x: '50%',
      y: '100px',
      dy: '50%',
      dx: '10%',
      // rotate: '45',
      lengthAdjust: 'spacingAndGlyphs',
      textLength: '200px',
    },
  }
  props.layer.setText(state.selectedFillText, textOptions)
}

const openIconSelector = () => {
  state.showIconSelector = true
}
const closeIconSelector = () => {
  state.showIconSelector = false
}
const selectIcon = (icon: { url: string; name: string }) => {
  state.selectedIcon = icon
  state.isIconSelected = true
  closeIconSelector()
  props.layer.setIcon(L.icon({ iconUrl: (state.selectedIcon as any).url }))
}
const updateFontColor = () => {
  // 更新文字颜色后，重新调用 `updateFontSize` 方法以应用新颜色
  updateFillText()
}

const updateFontFamily = () => {
  // 更新字体家族后，重新调用 `updateFontSize` 方法以应用新字体家族
  updateFillText()
}
</script>
